// Paket içi arama (ad ya da kod) + süzgeç çipleri (Tümü · Otomatik eklenen · Uyarılı · Taslakta
// değişen). Çipler `aria-pressed` düğmeleri (tek seçim); sayılar taslağı yansıtır.

import { useId } from "react";
import type { EditorCounts, PackageFilter } from "../../lib/kpi-package-editor";
import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";
import { decisionText, inputStyle } from "./kpi-form-styles";

const F = KPI_PACKAGES_COPY.filters;

export interface PackageEditorFiltersProps {
  search: string;
  onSearch: (v: string) => void;
  filter: PackageFilter;
  onFilter: (f: PackageFilter) => void;
  counts: EditorCounts;
}

export function PackageEditorFilters(p: PackageEditorFiltersProps): JSX.Element {
  const id = useId();
  const chip = (f: PackageFilter, label: string, n: number | null): JSX.Element => (
    <button
      key={f}
      type="button"
      aria-pressed={p.filter === f}
      onClick={() => p.onFilter(f)}
      style={{
        ...decisionText,
        fontSize: "0.875rem",
        minHeight: 44,
        padding: "4px 12px",
        borderRadius: 999,
        border: "1px solid var(--color-border)",
        cursor: "pointer",
        background:
          p.filter === f ? "color-mix(in srgb, var(--color-primary) 10%, white)" : "transparent",
        color: p.filter === f ? "var(--color-primary-text)" : "var(--color-text-2)",
        fontWeight: p.filter === f ? 600 : 400,
      }}
    >
      {n === null ? label : `${label} (${n})`}
    </button>
  );
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="package-filters">
      <label htmlFor={id} className="sr-only">
        {F.search}
      </label>
      <input
        id={id}
        type="search"
        value={p.search}
        placeholder={F.search}
        onChange={(e) => p.onSearch(e.target.value)}
        style={{ ...inputStyle, maxWidth: 320, minWidth: 200, flex: "0 1 320px" }}
      />
      <div role="group" aria-label={F.label} className="flex flex-wrap items-center gap-2">
        {chip("all", F.all, null)}
        {chip("auto", F.auto, p.counts.auto)}
        {chip("warning", F.warning, p.counts.warning)}
        {chip("changed", F.changed, p.counts.changed)}
      </div>
    </div>
  );
}
